module.exports = __webpack_public_path__ + "static/media/fly0247.3772165c.webp";